import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'
import type { Id } from '@/infra/id'
import { type ClientAssignmentViewModel } from '@/features/client-user-management/ClientAssignmentViewModel'
import {
  ClientUserAdvisor,
  ClientUserAdvisors,
} from '@/features/client-user-management/components/ClientUserDetailsInformation'

export interface ClientUserAdvisorsContainerProps {
  vm: ClientAssignmentViewModel
  /**
   * The link to an advisor's details.
   */
  getAdvisorLink: (userPublicId: Id) => string
}

/**
 * The card listing the client's advisors.
 */
export const ClientUserAdvisorsContainer = observer(
  function ClientUserAdvisorsContainer({
    vm,
    getAdvisorLink,
  }: ClientUserAdvisorsContainerProps) {
    const navigate = useNavigate()

    return (
      <ClientUserAdvisors isEmpty={!vm.advisors?.length}>
        {vm.advisors?.map((advisor) => (
          <ClientUserAdvisor
            key={advisor.user.publicId}
            avatar={{
              avatar: advisor.avatar,
              avatarFallback: advisor.avatarFallback,
              displayName: advisor.displayName,
            }}
            displayName={advisor.displayName}
            email={advisor.email}
            onPress={
              vm.canOpenAdvisors
                ? () => navigate(getAdvisorLink(advisor.user.publicId))
                : undefined
            }
            testId={`client-user-advisor-${advisor.user.publicId}`}
          />
        ))}
      </ClientUserAdvisors>
    )
  },
)
